/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceAgreementPropertiesType } from './ServiceAgreementPropertiesType';
import {
    ServiceAgreementPropertiesTypeFromJSON,
    ServiceAgreementPropertiesTypeFromJSONTyped,
    ServiceAgreementPropertiesTypeToJSON,
    ServiceAgreementPropertiesTypeToJSONTyped,
} from './ServiceAgreementPropertiesType';

/**
 * 
 * @export
 * @interface WealthPlanningServiceAgreementProperties
 */
export interface WealthPlanningServiceAgreementProperties {
    /**
     * 
     * @type {ServiceAgreementPropertiesType}
     * @memberof WealthPlanningServiceAgreementProperties
     */
    propertiesType: ServiceAgreementPropertiesType;
    /**
     * resolved server-side: true while the agreement is not ACTIVE; once ACTIVE, true only for CDS users. Ignored if sent back on write.
     * 
     * @type {boolean}
     * @memberof WealthPlanningServiceAgreementProperties
     */
    canCloseProduct?: boolean;
}



/**
 * Check if a given object implements the WealthPlanningServiceAgreementProperties interface.
 */
export function instanceOfWealthPlanningServiceAgreementProperties(value: object): value is WealthPlanningServiceAgreementProperties {
    if (!('propertiesType' in value) || value['propertiesType'] === undefined) return false;
    return true;
}

export function WealthPlanningServiceAgreementPropertiesFromJSON(json: any): WealthPlanningServiceAgreementProperties {
    return WealthPlanningServiceAgreementPropertiesFromJSONTyped(json, false);
}

export function WealthPlanningServiceAgreementPropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): WealthPlanningServiceAgreementProperties {
    if (json == null) {
        return json;
    }
    return {
        
        'propertiesType': ServiceAgreementPropertiesTypeFromJSON(json['propertiesType']),
        'canCloseProduct': json['canCloseProduct'] == null ? undefined : json['canCloseProduct'],
    };
}

export function WealthPlanningServiceAgreementPropertiesToJSON(json: any): WealthPlanningServiceAgreementProperties {
    return WealthPlanningServiceAgreementPropertiesToJSONTyped(json, false);
}

export function WealthPlanningServiceAgreementPropertiesToJSONTyped(value?: WealthPlanningServiceAgreementProperties | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertiesType': ServiceAgreementPropertiesTypeToJSON(value['propertiesType']),
        'canCloseProduct': value['canCloseProduct'],
    };
}

